import { coerceCalendarDate } from './calendarDateKey';

const normalizeText = (value = '') => String(value || '').replace(/\s+/g, ' ').trim();

const DOCTOR_VISIT_SIGNAL_PATTERN = /\b(?:Dr\.\s*[A-Z][a-z]+|doctor)\b/i;
const VISIT_CONTEXT_PATTERN = /\b(?:saw|visit(?:ed|ing)?|appointment|follow[- ]?up|asked|said|today)\b/i;
const FOLLOW_UP_PATTERN = /\bfollow[- ]?up\s+(?:in\s+)?([^.;]+)\.?/i;
const REASON_PATTERN = /\bfor\s+([^.;]+?)(?:\.|$)/i;
const GUIDANCE_PATTERN = /\b(?:watch for|call if)[^.]+\.?/i;
const DOCTOR_NAME_PATTERN = /\bDr\.\s*[A-Z][a-z]+(?:\s+[A-Z][a-z]+)?\b/;

const buildVisitDateTime = (selectedDate = null, selectedTime = '') => {
  const date = coerceCalendarDate(selectedDate) || (selectedDate instanceof Date ? selectedDate : null) || new Date();
  const visitDateTime = new Date(date);
  const timeParts = String(selectedTime || '').trim().match(/^(\d{1,2})(?::(\d{2}))?$/);

  if (timeParts) {
    visitDateTime.setHours(Number(timeParts[1]), Number(timeParts[2] || 0), 0, 0);
  }

  return visitDateTime;
};

export const hasQuickCheckInDoctorVisitSignal = (text = '') => {
  const normalized = normalizeText(text);
  return Boolean(normalized)
    && DOCTOR_VISIT_SIGNAL_PATTERN.test(normalized)
    && VISIT_CONTEXT_PATTERN.test(normalized);
};

export const buildQuickCheckInDoctorVisitData = ({
  text = '',
  selectedDate = null,
  selectedTime = '',
} = {}) => {
  const normalized = normalizeText(text);
  if (!hasQuickCheckInDoctorVisitSignal(normalized)) {
    return null;
  }

  const doctorName = normalized.match(DOCTOR_NAME_PATTERN)?.[0] || '';
  const reasonForVisit = normalizeText(normalized.match(REASON_PATTERN)?.[1] || '');
  const followUpDate = normalizeText(normalized.match(FOLLOW_UP_PATTERN)?.[1] || '');
  const guidance = normalizeText(normalized.match(GUIDANCE_PATTERN)?.[0] || '').replace(/[.]+$/, '');
  const visitDateTime = buildVisitDateTime(selectedDate, selectedTime);

  return {
    doctorName: doctorName || null,
    providerName: doctorName || null,
    providerSpecialty: '',
    organizationName: '',
    visitDateTime,
    visitAt: visitDateTime,
    visitDate: visitDateTime,
    reasonForVisit: reasonForVisit || null,
    treatmentRecommendations: guidance || null,
    summaryNotes: followUpDate ? `Follow-up in ${followUpDate}` : null,
    followUpDate: followUpDate || null,
  };
};
